import { getFieldsForGroups, sameDataValue } from '../../../../shared/dpRequests';

type Plain = Record<string, unknown>;

function isPlainObject(value: unknown): value is Plain {
    return typeof value === 'object' && value !== null && !Array.isArray(value) && Object.getPrototypeOf(value) === Object.prototype;
}

function isBinary(value: unknown): boolean {
    return (typeof File !== 'undefined' && value instanceof File) || (typeof Blob !== 'undefined' && value instanceof Blob);
}

export function sanitizeForSubmit(value: unknown): unknown {
    if (Array.isArray(value)) {
        return value.filter(item => !isBinary(item)).map(sanitizeForSubmit);
    }
    if (isPlainObject(value)) {
        const result: Plain = {};
        for (const [key, entry] of Object.entries(value)) {
            if (entry === undefined || isBinary(entry)) continue;
            result[key] = sanitizeForSubmit(entry);
        }
        return result;
    }
    return value;
}

export function pickGroupValues(data: Plain, groupIds: readonly string[]): Plain {
    const values: Plain = {};
    for (const field of getFieldsForGroups(groupIds)) {
        if (field in data) {
            values[field] = sanitizeForSubmit(data[field]) ?? null;
        }
    }
    return values;
}

export function pickChangedValues(data: Plain, groupIds: readonly string[], initial: Plain): Plain {
    const values: Plain = {};
    for (const field of getFieldsForGroups(groupIds)) {
        if (!(field in data)) continue;
        const current = sanitizeForSubmit(data[field]) ?? null;
        if (!sameDataValue(current, initial[field] ?? null)) {
            values[field] = current;
        }
    }
    return values;
}
